var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    !_vm.newCall &&
    _vm.atendimento &&
    (_vm.atendimento.queueTypeID === 3 ||
      _vm.atendimento.queueTypeID === 5 ||
      _vm.atendimento.queueTypeID === 6 ||
      _vm.atendimento.queueTypeID === 7 ||
      _vm.atendimento.queueTypeID === 8 ||
      _vm.atendimento.queueTypeID === 2)
  )?_c('Chat'):(!_vm.newCall && _vm.atendimento && _vm.atendimento.queueTypeID == 4)?_c('Email'):(_vm.newCall)?_c('Ligacao'):_c('v-card',{attrs:{"flat":"","color":"#F7F7F7"}},[_c('v-img',{staticClass:"mt-10",attrs:{"src":require("@/assets/fundowhats.jpeg"),"aspect-ratio":"2","contain":"","max-height":"100%"}}),_c('h5',{staticStyle:{"text-align":"center","color":"#666"}},[_vm._v("Xcontact Omni Channel")]),_c('p',{staticStyle:{"text-align":"center !important","color":"#666"}},[_vm._v(" "+_vm._s(_vm.t("fraseInicial"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }